import { Link } from 'react-router-dom';
import './CounsellingCard.css';

const CounsellingCard = (props:any) => {
    const {
      imageSrc,
      title,
      description,
      buttonText,
      linkTo,
      backgroundColor = '#ffffff',
      textColor = '#000000',
      textColorTitle = '#000000',
    } = props;
  return (
    <div
      className="counselling-card"
      style={{ background: backgroundColor, color: textColor }}
    >
      <img src={imageSrc} alt="Counselling" className="counselling-img" />
      <h3 style={{color: textColorTitle}}>{title}</h3>
      <p style={{color: textColorTitle}}>{description}</p>
      <Link to={linkTo} className="counselling-btn-link">
        <button
          className="counselling-btn"
          style={{ color: textColor, borderColor: textColor }}
        >
          {buttonText}
        </button>
      </Link>
    </div>
  );
};

export default CounsellingCard;
